import { useQuery } from "@tanstack/react-query"

import { bffApi } from "../apiClient"
import formatDateStringToYYMMDD from "../helpers/formatDateStringToYYMMDD"
import { Guest } from "../models"
import queryKeys from "../queryKeys"

const useSavedGuestsQuery = () => {
  return useQuery<Guest[]>({
    queryKey: queryKeys.guests,
    queryFn: async () => {
      const res = await bffApi.get<{ guests: Guest[] }>("/guests")
      return res.data.guests
    },
    select: (data) => {
      return data.map((guest) => ({
        ...guest,
        birthDate: formatDateStringToYYMMDD(guest.birthDate),
      }))
    },
    staleTime: 5 * 60 * 1000,
  })
}

export default useSavedGuestsQuery
